/* eslint-disable eqeqeq */
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import { useContext, useEffect, useRef, useState } from "react"
import { useFormik } from "formik"
import "../../components/Appointments/lib/cron.js"
import "../../components/Appointments/lib/cron"
import { DateTime } from "luxon"
import { Chance } from "chance"
import ParticipantProfileBoxSmall from "../../components/ParticipantProfileBoxSmall/index.js"

//graphQL
import { useQuery } from "@apollo/client"
import { GET_PARTICIPANT, GET_SERVICES } from "./queries"
import styles from "../../styles/Home-Staff.module.css"

// Context
import { UserContext } from "../../context/userContext"

//Appointments
import {
  createNewAppointment,
  declineParticipantAppointment,
  getAllMinifiedAppointments,
  updateAppointment,
  cancelAppointment,
} from "../../components/Appointments/AppointmentsApi"
import {
  formatDate,
  timezones,
  durations,
  groupFilterTemplate,
  engagementChannels,
  editChannelSelect,
  isFormFieldValid,
  customStyles,
  formatOrgCalDate,
  reformatAppointment,
  acceptRequestedSchedule,
  getDateKey,
  getDate,
} from "../../components/Appointments/utils"

import { generateFutureRecurringEventsForControllers } from "../../components/Appointments/utilsRecurringControllers"

//helpers
import { LogError } from "../../helpers/logger"

//PrimeReact
import { Toast } from "primereact/toast"
import { Dialog } from "primereact/dialog"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { TabView, TabPanel } from "primereact/tabview"
import { Calendar } from "primereact/calendar"
import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { Dropdown } from "primereact/dropdown"
import { ToggleButton } from "primereact/togglebutton"
import { MultiSelect } from "primereact/multiselect"
import { classNames } from "primereact/utils"
import { Tooltip } from "primereact/tooltip"

//PrimeReact
import { ProgressSpinner } from "primereact/progressspinner"
import AppointmentsTablePending from "../../components/Appointments/AppointmentsTablePending"
import AppointmentsTableDeclined from "../../components/Appointments/AppointmentsTableDeclined"
import {
  applyAppointmentFilters,
  filterServiceTemplates,
} from "../../components/Appointments/utilsFilters.js"
import AppointmentsFormCron from "../../components/Appointments/AppointmentsFormCron.js"
import isParticipantActive from "../../helpers/isParticipantActive.js"

export default function Appointments() {
  const userCtx = useContext(UserContext)

  const [isLoadingAppointments, setIsLoadingAppointments] = useState(true)
  const [data, setData] = useState([])
  const [activeStaffSchedulingIndex, setActiveStaffSchedulingIndex] =
    useState(0)

  //Cache of unfiltered appointments data as received from API
  const [cached_pastAppointments, setCachedPastAppointments] = useState([])
  const [cached_upcomingAppointments, setCachedUpcomingAppointments] = useState(
    [],
  )
  const [cached_pendingAppointments, setCachedPendingAppointments] = useState(
    [],
  )
  const [
    cached_recurringParticipantControllers,
    setCachedRecurringParticipantControllers,
  ] = useState([])

  //Active appointments data lists used in UI
  const [pastAppointments, setPastAppointments] = useState([])
  const [upcomingAppointments, setUpcomingAppointments] = useState([])
  const [pendingAppointments, setPendingAppointments] = useState([])
  const [recurringParticipantControllers, setRecurringParticipantControllers] =
    useState([])
  const [participant, setParticipant] = useState(null)
  const toast = useRef(null)
  const [isCalendarView, setIsCalendarView] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState([])
  const [date2, setDate2] = useState([
    DateTime.local().plus({ day: -30 }).toJSDate(),
    DateTime.local().plus({ day: 30 }).toJSDate(),
  ])
  const [groupedFilters, setGroupFilters] = useState(groupFilterTemplate)
  const [date, setDate] = useState(new Date())
  const [selectedDateView, setSelectedDateView] = useState(null)
  const [confirmModalIsOpen, setConfirmIsOpen] = useState(false)
  const [confirming, setConfirming] = useState({ mode: "", message: "" })

  const [services, setServices] = useState([]) //Used to identify the available service types for new appointments

  const [modalIsOpen, setIsOpen] = useState(false)
  const [apptModalMode, setApptModalMode] = useState("Submit Appointment")

  const [activeCron, setActiveCron] = useState(undefined)

  const [editingRulesForController, setEditingRulesForController] =
    useState(false)

  const allowNewAppointments = isParticipantActive(
    userCtx.participant_membership_status,
  )

  const activeAppointment = useFormik({
    initialValues: {
      id: 0,
      serviceName: "Intake Session",
      duration: { code: "30m", name: "30 minutes" },
      engagementChannel: "telephone",
      location: "",
      timezone: {
        code: DateTime.local().toFormat("z"),
        name: timezones.find((x) => x.code == DateTime.local().toFormat("z"))
          ? timezones.find((x) => x.code == DateTime.local().toFormat("z")).name
          : timezones[0].name,
      },
      isRecurring: false,
      startDate: new Date(),
      startTime: new Date(),
      endTime: new Date(),
      cron: null,
      participant: { code: "", name: "" },
      sendEmailNotifications: true,
      sendSMSNotifications: true,
      cronDescription: "",
      isRecurringController: false,
    },
    validate: (data) => {
      let errors = {}
      if (!data.startDate) {
        errors.startDate = "Date is required."
      }

      if (!data.startTime) {
        errors.startTime = "Time is required."
      }

      if (!data.participant) {
        errors.participant = "Participant is required."
      }

      return errors
    },
    onSubmit: (data) => {
      //activeAppointment.resetForm()
    },
  })

  const { refetch: loadFromList } = useQuery(GET_PARTICIPANT, {
    variables: {
      participant_id: userCtx.current_participant_id,
      organization_id: userCtx.session.user.organization_id,
    },
    onError: (e) => {
      LogError("Unable to retrieve participant details", e)
    },
    onCompleted: (participant_result) => {
      setParticipant(participant_result.participant)
      activeAppointment.setFieldValue("participant", {
        code: participant_result.participant.participant_alias,
        name:
          participant_result.participant.participant_name_first +
          " " +
          participant_result.participant.participant_name_last,
        firstName: participant_result.participant.participant_name_first,
        lastName: participant_result.participant.participant_name_last,
        email: participant_result.participant.participant_email_account,
        phone: participant_result.participant.participant_phone_primary,
        alias: participant_result.participant.participant_id,
      })
    },
  })

  const { refetch: loadServices } = useQuery(GET_SERVICES, {
    fetchPolicy: "network-only",
    skip: true,
    variables: {
      organization_id: userCtx.session.user.organization_id,
      template_type: "session_module",
    },
    onError: (e) => {
      console.error("ERR-SERV", e)
      // props.onShowError("Unable to retrieve user information, please refer to the console for more information")
      //setLoading(false)
    },
    onCompleted: (data) => {
      const servicesFromTemplates = filterServiceTemplates(
        data.getTemplatesByOrganization,
      ).map((x) => x.template_title)

      setServices(servicesFromTemplates)

      let modifiedGroup = groupedFilters
      modifiedGroup[0].items = servicesFromTemplates.map((x) => {
        return { label: x, value: x }
      })
      setGroupFilters(modifiedGroup)
    },
  })

  async function getParticipantAppointments() {
    try {
      if (!!selectedDateView) {
        setIsLoadingAppointments(true)
        const fromDate = DateTime.fromJSDate(selectedDateView.from)
        const toDate = DateTime.fromJSDate(selectedDateView.to)

        //Retrieve previous appointments
        let res2 = await getAllMinifiedAppointments(
          userCtx.tokens.getAppointmentsToken(),
          null,
          fromDate.minus({ days: 120 }).toFormat("yyyy-MM-dd"),
          fromDate.toFormat("yyyy-MM-dd"),
          participant.participant_alias,
        )
        if (res2.successful) {
          let pastAppts = res2.data
            .map((x) => {
              x = formatDate(x)
              return x
            })
            .filter(
              (x) =>
                getDate(x.startDateTime).toUnixInteger() <
                fromDate.toUnixInteger(),
            )

          let res3 = await getAllMinifiedAppointments(
            userCtx.tokens.getAppointmentsToken(),
            null,
            fromDate.toFormat("yyyy-MM-dd"),
            toDate.toFormat("yyyy-MM-dd"),
            participant.participant_alias,
          )
          if (res3.successful) {
            const newPastAppointments = res3.data
              .filter((x) => {
                if (!!x.startDateTime) {
                  const startDate = getDate(x.startDateTime)
                  const currentDate = DateTime.local()

                  return startDate < currentDate
                } else {
                  return false
                }
              })
              .reverse()
              .concat(pastAppts)

            const activeAppointments = res3.data
              .map((x) => {
                x = formatDate(x)
                return x
              })
              .filter((x) =>
                !!x.startDateTime
                  ? getDate(x.startDateTime).toUnixInteger() >
                    DateTime.local().toUnixInteger()
                  : false,
              )

            await getRecurringParticipantAppointments(
              newPastAppointments,
              activeAppointments,
            )
          }
        } else {
          setUpcomingAppointments([])
          setCachedUpcomingAppointments([])
          setRecurringParticipantControllers([])
          setCachedRecurringParticipantControllers([])
          setPastAppointments([])
          setCachedPastAppointments([])
        }

        setIsLoadingAppointments(false)
      } else {
        if (isCalendarView) {
          setSelectedDateViewValue(DateTime.local().startOf("month").toJSDate())
        } else {
          setSelectedDateViewValue(
            DateTime.local().plus({ day: -30 }).toJSDate(),
            DateTime.local().plus({ day: 30 }).toJSDate(),
          )
        }
      }
    } catch (error) {
      LogError("Unable to load participant appointments", error)
      userCtx.setNotificationError("Unable to load participant appointments")
      setUpcomingAppointments([])
      setCachedUpcomingAppointments([])
      setRecurringParticipantControllers([])
      setCachedRecurringParticipantControllers([])
      setPastAppointments([])
      setCachedPastAppointments([])
      setCachedPastAppointments([])
      setIsLoadingAppointments(false)
    }
  }

  async function getPendingAppointments() {
    try {
      let res4 = await getAllMinifiedAppointments(
        userCtx.tokens.getAppointmentsToken(),
        null,
        DateTime.local().minus({ days: 120 }).toFormat("yyyy-MM-dd"),
        DateTime.local().plus({ days: 1 }).toFormat("yyyy-MM-dd"),
        participant.participant_alias,
        false,
        true,
      )
      if (res4.successful) {
        const newPendingAppointments = res4.data.map((x) => {
          x = formatDate(x)
          return x
        })

        setPendingAppointments(newPendingAppointments)
        setCachedPendingAppointments(newPendingAppointments)
      } else {
        setPendingAppointments([])
        setCachedPendingAppointments([])
        LogError("An error ocurred while retrieving pending appointments", res4)
        toast.current.show({
          severity: "error",
          detail: `An error ocurred while retrieving pending appointments: ${res4.message}`,
          life: 9000,
        })
      }
    } catch (error) {
      LogError("An error ocurred while retrieving pending appointments", error)

      toast.current.show({
        severity: "error",
        detail: `An error ocurred while retrieving pending appointments: ${error.message}`,
        life: 9000,
      })

      throw error
    }
  }

  async function getRecurringParticipantAppointments(past, upcoming) {
    let start = selectedDateView?.from
      ? DateTime.fromJSDate(selectedDateView?.from)
      : DateTime.local()
    let end = selectedDateView?.to
      ? DateTime.fromJSDate(selectedDateView?.to)
      : DateTime.local().plus({ days: 14 })
    let res = await getAllMinifiedAppointments(
      userCtx.tokens.getAppointmentsToken(),
      null,
      start.toFormat("yyyy-MM-dd"),
      end.toFormat("yyyy-MM-dd"),
      participant.participant_alias,
      true,
      null,
      null,
    )
    if (res.successful) {
      let recurringAppts = res.data

      let generated = []
      for (let obj of recurringAppts) {
        let startDateTimeActual = DateTime.fromFormat(
          obj.startDateTime,
          getDateKey(obj.startDateTime),
          {
            zone: obj.timezone || obj.timezoneName,
          },
        ).setZone(DateTime.local().toFormat("z"))

        let frequency = obj.frequency.split(" | ")

        frequency[2] = startDateTimeActual.toFormat("hh:mm a")
        let newFreq
        obj.isRecurringController = true
        obj.frequency = frequency.join(" | ")

        if (
          frequency[1] == "Daily" &&
          frequency[frequency.length - 1].includes(":")
        ) {
          newFreq = frequency[1]
        } else {
          newFreq = frequency[1] + " | " + frequency[frequency.length - 1]
        }

        obj.newFreq = newFreq
        obj = formatDate(obj)

        const futureAppointments = generateFutureRecurringEventsForControllers(
          [obj],
          upcoming,
          selectedDateView?.from,
          selectedDateView?.to,
        )

        for (let futureAppointment of futureAppointments) {
          generated.push({
            ...futureAppointment,
            isRecurringController: false,
            scheduledTime:
              getDate(futureAppointment.startDateTime)
                .toLocal()
                .toFormat("hh:mm a") +
              "-" +
              getDate(futureAppointment.endDateTime)
                .toLocal()
                .toFormat("hh:mm a"),
          })
        }
      }

      setRecurringParticipantControllers(recurringAppts)
      setCachedRecurringParticipantControllers(recurringAppts)

      const formattedUpcoming = upcoming.map((x) => {
        x = formatDate(x)
        return x
      })

      const chance = new Chance()
      generated = generated.map((generatedEntry) => {
        return {
          ...generatedEntry,
          id: `recurring_${chance.string({
            length: 4,
            alpha: true,
          })}_${generatedEntry.id}`,
        }
      })

      const pastGenerated = generated.filter(
        (x) => DateTime.fromISO(x.startDateTime) < DateTime.local(),
      )
      const upcomingGenerated = generated.filter(
        (x) => DateTime.fromISO(x.startDateTime) >= DateTime.local(),
      )

      const newAppointments = [...formattedUpcoming, ...upcomingGenerated]
      const newPastAppointments = [...past, ...pastGenerated]

      setPastAppointments(newPastAppointments)
      setCachedPastAppointments(newPastAppointments)

      setCachedUpcomingAppointments(newAppointments)
      setUpcomingAppointments(newAppointments)
    }
  }

  const setSelectedDateViewValue = (fromDate, toDate) => {
    if (!fromDate) {
      fromDate = DateTime.local().startOf("day").toJSDate()
    } else {
      fromDate = DateTime.fromJSDate(fromDate).startOf("day").toJSDate()
    }

    if (!toDate) {
      //If no end date is specified, set the date to the end of the month
      toDate = DateTime.fromJSDate(fromDate).endOf("month").toJSDate()
    }

    setSelectedDateView({ from: fromDate, to: toDate })
  }

  const filterAppointments = () => {
    const getFilteredList = (list, isRecurring, ignoreDateFilter) => {
      return applyAppointmentFilters(
        list,
        selectedFilters,
        services,
        date2,
        ignoreDateFilter || isCalendarView,
        isRecurring,
      )
    }

    const filteredUpcoming = getFilteredList(cached_upcomingAppointments)
    setUpcomingAppointments(filteredUpcoming)

    const filteredRecurring = getFilteredList(
      cached_recurringParticipantControllers,
      true,
    )
    setRecurringParticipantControllers(filteredRecurring)

    const filteredPast = getFilteredList(cached_pastAppointments)
    setPastAppointments(filteredPast)

    const filteredPending = getFilteredList(
      cached_pendingAppointments,
      false,
      true,
    )
    setPendingAppointments(filteredPending)

    if (isCalendarView) {
      updateList(date, [...filteredUpcoming, ...filteredPast])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  const refresh = () => {
    getParticipantAppointments()
    getPendingAppointments()
  }

  useEffect(() => {
    filterAppointments()
  }, [selectedFilters, cached_upcomingAppointments])

  useEffect(() => {
    // Update the document title using the browser API

    if (userCtx != undefined && participant != null) {
      loadFromList()
      loadServices()
      setRecurringParticipantControllers([])
      setCachedRecurringParticipantControllers([])
      setPastAppointments([])
      setCachedPastAppointments([])
      getParticipantAppointments()
      getPendingAppointments()
    }
  }, [participant]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (userCtx.refreshTrigger) {
      refresh()
    }
  }, [userCtx.refreshTrigger]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!selectedDateView) {
      if (
        selectedDateView.from !== date2.from ||
        selectedDateView.to !== date2.to
      ) {
        setDate2([selectedDateView.from, selectedDateView.to])
      }

      refresh()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDateView])

  function closeModal() {
    setIsOpen(false)
    activeAppointment.resetForm()
    setEditingRulesForController(false)
    setApptModalMode("Submit Appointment")
    activeAppointment.setFieldValue("participant", {
      code: participant.participant_alias,
      name:
        participant.participant_name_first +
        " " +
        participant.participant_name_last,
      firstName: participant.participant_name_first,
      lastName: participant.participant_name_last,
      email: participant.participant_email_account,
      phone: participant.participant_phone_primary,
      alias: participant.participant_id,
    })
  }

  async function submitNewAppointment() {
    let cron = activeAppointment.values.isRecurringController
      ? activeCron.cronValue
      : null

    let cronPeriod = activeAppointment.values.isRecurringController
      ? activeCron.period
      : null

    const userValues = {
      organization_id: userCtx.session.user.organization_id,
      organization_alias: userCtx.session.user.organization_alias,
      staff_id: userCtx.session.user.staff_id,
      staff_alias: userCtx.session.user.staff_alias,
      staff_name_first: userCtx.session.user.staff_name_first,
      staff_name_last: userCtx.session.user.staff_name_last,
      staff_email_address: userCtx.session.user.staff_email_address,
    }

    let payload = reformatAppointment(
      activeAppointment,
      userValues,
      null,
      false,
      apptModalMode.includes("Edit"),
      activeAppointment.values.isRecurringController,
      editingRulesForController,
      false,
      cron,
      toast,
      cronPeriod,
    )
    if (payload) {
      try {
        let res
        if (activeAppointment.values.id !== 0) {
          res = await updateAppointment(
            userCtx.tokens.getAppointmentsToken(),
            activeAppointment.values.id,
            payload,
          )
        } else {
          res = await createNewAppointment(
            userCtx.tokens.getAppointmentsToken(),
            payload,
          )
        }
        if (res.successful) {
          toast.current.show({
            severity: "success",
            detail: `Successfully scheduled appointment`,
            life: 3000,
          })
          closeModal()
          userCtx.refreshData()
        } else {
          toast.current.show({
            severity: "error",
            detail: res.error,
            life: 9000,
          })
        }
      } catch (e) {
        toast.current.show({
          severity: "error",
          detail: e.message,
          life: 9000,
        })
      }
    }
  }

  async function confirmAction() {
    if (confirming.mode == "cancelAppointment") {
      cancelAppt(false, true)
    }
  }

  function toggleRecurringAppt() {
    //Get the recurring startTime in the specified timezone
    const workingStartTimeInZone = activeAppointment.values.startTime
      ? DateTime.fromJSDate(activeAppointment.values.startTime).setZone(
          activeAppointment.values.timezone.code,
        )
      : null

    //Set the time to the TZ time in local to display correct time in calendar
    const workingStartTime = workingStartTimeInZone
      ? DateTime.fromJSDate(activeAppointment.values.startTime)
          .set({
            hour: workingStartTimeInZone.hour,
            minute: workingStartTimeInZone.minute,
            second: 0,
            millisecond: 0,
          })
          .toJSDate()
      : null

    const handleStartTimeUpdate = (e) => {
      const newStartTime = DateTime.fromJSDate(e.value).setZone(
        activeAppointment.values.timezone.code,
        {
          keepLocalTime: true,
        },
      )

      const changeEvent = { ...e, value: newStartTime.toJSDate() }
      changeEvent.target.value = newStartTime.toJSDate()

      activeAppointment.handleChange(changeEvent)
    }

    if (!activeAppointment.values.isRecurringController) {
      return (
        <>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Appointment Date</label>
            <br />
            <Calendar
              id="startDate"
              style={customStyles.inputStyle}
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.startDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "startDate"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">Appointment Time</label>
            <br />
            <Calendar
              id="startTime"
              style={customStyles.inputStyle}
              onChange={handleStartTimeUpdate}
              value={workingStartTime}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "startTime"),
              })}
              timeOnly
              hourFormat="12"
            />
          </div>
        </>
      )
    } else {
      return (
        <>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Start Date</label>
            <br />
            <Calendar
              id="startDate"
              style={customStyles.inputStyle}
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.startDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "startDate"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">End Date</label>
            <br />
            <Calendar
              id="endDate"
              style={customStyles.inputStyle}
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.endDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "endDate"),
              })}
            />
          </div>
          <div style={{ ...customStyles.inputField, width: "95%" }}>
            <div
              hidden={
                apptModalMode.includes("Edit") && !editingRulesForController
              }
            >
              <AppointmentsFormCron
                cronValues={activeCron}
                startTime={activeAppointment?.values?.startTime}
                startTimeTimezoneCode={
                  activeAppointment?.values?.timezone?.code
                }
                onChangeCronValues={(cron) => {
                  setActiveCron(cron)
                }}
              />
              <br />
              <div style={{ ...customStyles.inputField, width: "100%" }}>
                <label htmlFor="startTime">Start Time</label>
                <br />
                <Calendar
                  id="startTime"
                  style={customStyles.inputStyle}
                  onChange={handleStartTimeUpdate}
                  value={workingStartTime}
                  className={classNames({
                    "p-invalid": isFormFieldValid(
                      activeAppointment,
                      "startTime",
                    ),
                  })}
                  timeOnly
                  hourFormat="12"
                />
              </div>
            </div>
            <div
              hidden={
                apptModalMode.includes("Submit") ||
                editingRulesForController ||
                activeAppointment.values.isRecurringController == false
              }
            >
              <div style={{ ...customStyles.inputField, width: "95%" }}>
                <label htmlFor="">Recurring Rules:</label>
                <br />
                <span>{activeAppointment.values.cronDescription}</span> |{" "}
                <button
                  type="button"
                  className="btn-sm"
                  onClick={() => setEditingRulesForController(true)}
                >
                  Change
                </button>
                <br />
              </div>
            </div>
          </div>
        </>
      )
    }
  }

  async function updateList(newDate, newUpcomingAppointments) {
    setDate(newDate)

    const useUpcomingAppointments = !!newUpcomingAppointments
      ? newUpcomingAppointments
      : [...upcomingAppointments, ...pastAppointments]

    let filtered = useUpcomingAppointments.filter((x) => {
      let startUnix = getDate(x.startDateTime)
      let selectedUnix = DateTime.fromJSDate(newDate)

      return (
        startUnix >= selectedUnix && startUnix < selectedUnix.plus({ days: 1 })
      )
    })
    setData(filtered)
    activeAppointment.setFieldValue("startDate", newDate)
  }

  async function acceptParticipantAppointment(rowData) {
    const participantProfile = {
      code: participant.participant_alias,
      alias: participant.participant_id, //Note that the below call requires the SOAR ID as the alias
    }

    const userValues = {
      organization_id: userCtx.session.user.organization_id,
      organization_alias: userCtx.session.user.organization_alias,
      staff_id: userCtx.session.user.staff_id,
      staff_alias: userCtx.session.user.staff_alias,
      staff_name_first: userCtx.session.user.staff_name_first,
      staff_name_last: userCtx.session.user.staff_name_last,
      staff_email_address: userCtx.session.user.staff_email_address,
    }

    let payload = acceptRequestedSchedule(
      rowData,
      userValues,
      [participantProfile],
      toast,
    )

    try {
      let res
      const appointmentId = rowData.appointmentId

      if (rowData.type === "RESCHEDULE") {
        // This is a reschedule request
        let editPayload = {
          serviceName: payload.appointmentDetails.serviceName,
          startDateTime: payload.appointmentDetails.startDateTime,
          cron: rowData.cron,
          editingRecurringController: rowData.isRecurring,
          changingRules: rowData.isRecurring,
          recurringDuration: getDate(
            payload.appointmentDetails.endDateTime,
          ).diff(getDate(payload.appointmentDetails.startDateTime), ["minutes"])
            .minutes,
          endDateTime: payload.appointmentDetails.endDateTime,
          metadata: payload.appointmentDetails.metadata,
          alias: {
            orgAlias: userCtx.session.user.organization_id,
            staffAlias: userCtx.session.user.staff_id,
            participantAlias: payload.caseUserDetails.alias.participantAlias,
          },
          timezoneName: rowData.timezone,
        }

        // Check for recurring appointment and add appointmentRequest details
        let cancelledDate = ""
        if (appointmentId.includes("recurring_")) {
          let appointmentDetails = {
            orgId: userCtx.session.user.organization_alias,
            participantEmail: rowData.caseEmail,
            participantName: rowData.participantName,
            participantPhone: rowData.casePhone,
            bookedBy: userCtx.session.user.staff_email_address,
            startDateTime: payload.appointmentDetails.startDateTime,
            endDateTime: payload.appointmentDetails.endDateTime,
            serviceName: payload.appointmentDetails.serviceName,
            staffId: userCtx.session.user.staff_alias,
            timezoneName: rowData.timezone,
          }
          editPayload.appointmentRequest = appointmentDetails

          if (!rowData.isRecurring) {
            // Only applicable to single future instances of a recurring controller
            // Set cancelled date to the original appointment date
            cancelledDate = getDate(rowData.recurringStartDate).valueOf()
          }
        }

        res = await updateAppointment(
          userCtx.tokens.getAppointmentsToken(),
          appointmentId,
          editPayload,
          cancelledDate,
        )
      } else if (rowData.type === "CANCELLING") {
        res = await cancelAppointment(
          userCtx.tokens.getAppointmentsToken(),
          rowData.appointmentId,
          getDate(rowData.startDateTime).valueOf(),
          rowData.isRecurring,
        )
        await cancelAppt(true)
      } else {
        res = await createNewAppointment(
          userCtx.tokens.getAppointmentsToken(),
          payload,
        )
      }

      if (res.successful) {
        await declineParticipantAppointment(
          userCtx.tokens.getAppointmentsToken(),
          rowData.id,
          rowData.type !== "CANCELLING",
          rowData.type === "CANCELLING",
        )

        if (rowData.type === "CANCELLING") {
          toast.current.show({
            severity: "success",
            detail: `Successfully cancelled appointment`,
            life: 3000,
          })
        } else {
          toast.current.show({
            severity: "success",
            detail: `Successfully scheduled accepted appointment`,
            life: 3000,
          })
        }

        refresh()
      } else {
        userCtx.setNotificationError(
          `Unable to accept appointment request ${
            !!res?.error ? ": " + res.error : ""
          }`,
        )
      }
    } catch (error) {
      LogError("An error occurred while accepting the appointment", error)

      toast.current.show({
        severity: "error",
        detail: `An error occurred while accepting the appointment: ${error.message}`,
        life: 9000,
      })

      throw error
    }
  }

  async function deleteRequest(id) {
    try {
      let res = await declineParticipantAppointment(
        userCtx.tokens.getAppointmentsToken(),
        id,
        false,
      )

      if (res.successful) {
        toast.current.show({
          severity: "success",
          detail: `This appointment request has been denied`,
          life: 3000,
        })
        setPendingAppointments([])
        setCachedPendingAppointments([])
        await getPendingAppointments()
      } else {
        LogError("Unable to delete request", res.message)
        toast.current.show({
          severity: "error",
          detail: `Unable to delete request: ${res.message}`,
          life: 9000,
        })
      }
    } catch (error) {
      LogError("An error ocurred while deleting the appointment", error)

      toast.current.show({
        severity: "error",
        detail: `An error ocurred while deleting the appointment: ${error.message}`,
        life: 9000,
      })

      throw error
    }
  }

  function PendingAppointmentsActions(rowData) {
    if (
      rowData.peerId === userCtx.session.user.staff_id ||
      rowData.peerId === userCtx.session.user.staff_alias
    ) {
      return (
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          <button
            type="submit"
            className="btn-sm btn-info"
            style={{ background: "#00508e", marginRight: "5px" }}
            onClick={() => acceptParticipantAppointment(rowData)}
          >
            Accept
          </button>
          <button
            type="submit"
            className="btn-sm btn-danger"
            onClick={() => deleteRequest(rowData.id)}
          >
            Deny
          </button>
        </div>
      )
    } else {
      return null
    }
  }

  function openEditModal(data) {
    setApptModalMode("Edit Appointment")
    setEditingRulesForController(false)
    activeAppointment.resetForm()

    let cron = ""
    let cronDescription = ""

    if (data.isRecurringController) {
      if (data.recurringController) {
        cron = data.recurringController.cronExpression
        cronDescription = data.recurringController.cronDescription
      } else {
        cron = data?.cron
        cronDescription = data?.frequency
      }
    }

    data.participant = participant

    const userValues = {
      organization_id: userCtx.session.user.organization_id,
      organization_alias: userCtx.session.user.organization_alias,
      staff_id: userCtx.session.user.staff_id,
      staff_alias: userCtx.session.user.staff_alias,
      staff_name_first: userCtx.session.user.staff_name_first,
      staff_name_last: userCtx.session.user.staff_name_last,
      staff_email_address: userCtx.session.user.staff_email_address,
    }

    activeAppointment.setValues(
      reformatAppointment(
        activeAppointment,
        userValues,
        data,
        true,
        false,
        data.isRecurringController,
        false,
        true,
        cron,
        toast,
      ),
    )

    setActiveCron({
      cronValue: cron,
      cronDescription: cronDescription,
    })

    activeAppointment.setFieldValue("participant", {
      code: participant.participant_alias,
      name:
        participant.participant_name_first +
        " " +
        participant.participant_name_last,
      firstName: participant.participant_name_first,
      lastName: participant.participant_name_last,
      email: participant.participant_email_account,
      phone: participant.participant_phone_primary,
      alias: participant.participant_id,
    })

    setIsOpen(true)
  }

  function openModal() {
    setIsOpen(true)

    const defaultStartDate = DateTime.fromJSDate(date)

    setActiveCron({
      cronValue: `${defaultStartDate.minute} ${defaultStartDate.hour} * * *`,
      cronDescription: "",
      period: "Daily",
    })

    activeAppointment.resetForm()

    setEditingRulesForController(false)
    activeAppointment.setFieldValue("participant", {
      code: participant.participant_alias,
      name:
        participant.participant_name_first +
        " " +
        participant.participant_name_last,
      firstName: participant.participant_name_first,
      lastName: participant.participant_name_last,
      email: participant.participant_email_account,
      phone: participant.participant_phone_primary,
      alias: participant.participant_id,
    })
  }

  function EditAppointmentsColumnBody(rowData) {
    const onClick = () => {
      /*       if(!!rowData.frequency){
        const controller = recurringAppointments.filter(x => x.id.toString() === rowData.id)
        if(controller.length > 0){
          openEditModal(controller[0])
        }else{
          user.setNotificationError("Unable to find the recurring appointment controller for this instance")
        }
      }else{ 
        openEditModal(rowData)
      }  */
      openEditModal(rowData)
    }
    return (
      <button
        className="btn"
        onClick={onClick}
        style={{ width: "50px", paddingLeft: "12px" }}
      >
        Edit
      </button>
    )
  }

  function EditRecurringAppointmentsColumnBody(rowData) {
    const onClick = () => {
      const controller = recurringParticipantControllers.filter(
        (x) => x.id.toString() === rowData.id,
      )
      if (controller.length > 0) {
        openEditModal(controller[0])
      } else {
        userCtx.setNotificationError(
          "Unable to find the recurring appointment controller for this instance",
        )
      }
    }

    return (
      <button
        className="btn"
        onClick={onClick}
        style={{ width: "50px", paddingLeft: "12px" }}
      >
        Edit
      </button>
    )
  }

  async function cancelAppt(skip = false, toggleConfirmed) {
    let res = {}

    if (toggleConfirmed === false) {
      setConfirming({
        mode: "cancelAppointment",
        message: "Are you sure you want to cancel this appointment? ",
      })
      setConfirmIsOpen(true)
      return
    } else {
      setConfirmIsOpen(false)
    }

    if (!skip) {
      res = await cancelAppointment(
        userCtx.tokens.getAppointmentsToken(),
        activeAppointment.values.id,
        DateTime.fromJSDate(activeAppointment.values.startDate).valueOf(),
        activeAppointment.values.isRecurringController || false,
      )
    } else {
      res.successful = true
    }

    if (res.successful) {
      if (!skip) {
        toast.current.show({
          severity: "success",
          detail: "Successfully cancelled appointment",
          life: 3000,
        })
      }
      userCtx.refreshData()
      closeModal()
    } else {
      toast.current.show({
        severity: "error",
        detail: "Error cancelling appointment",
        life: 3000,
      })
    }
  }

  return (
    <div className="layout-with-sidebar">
      <Toast ref={toast} position="top-right" />

      <div className="sidebar">
        <ParticipantSidebar />
      </div>
      <div className="main-content">
        <ParticipantProfileBoxSmall />
        <Tooltip
          target=".tt-disabledNewAppointment"
          className="custom-tooltip"
        />
        <h1>Appointments</h1>
        <div
          className={classNames(
            styles.buttonContainer,
            allowNewAppointments ? "" : "tt-disabledNewAppointment",
          )}
          data-pr-tooltip="Unable to schedule new appointments for inactive participants"
          data-pr-position="bottom"
        >
          <button
            type="submit"
            className="btn"
            onClick={openModal}
            disabled={!allowNewAppointments}
          >
            Schedule New Appointment
          </button>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px",
            alignItems: "baseline",
          }}
        >
          <ToggleButton
            onLabel="Calendar View"
            offLabel="List View"
            onIcon="pi pi-calendar"
            offIcon="pi pi-align-justify"
            checked={isCalendarView}
            onChange={(e) => {
              setIsCalendarView(e.value)

              if (e.value) {
                setSelectedDateViewValue(
                  DateTime.now().startOf("month").toJSDate(),
                )
              } else {
                const from = DateTime.fromJSDate(selectedDateView.from).plus({
                  days: -30,
                })
                const to = DateTime.fromJSDate(selectedDateView.to).plus({
                  days: 30,
                })

                setSelectedDateViewValue(from.toJSDate(), to.toJSDate())
              }
            }}
          />

          <div hidden={isCalendarView} style={{ width: "22%" }}>
            <Calendar
              id="range"
              style={{ width: "100%" }}
              value={date2}
              onChange={(e) => {
                setDate2(e.value)

                if (!e.value.includes(null)) {
                  setSelectedDateViewValue(e.value[0], e.value[1])
                }
              }}
              selectionMode="range"
              readOnlyInput
              placeholder="Date Range"
            />
          </div>
          <MultiSelect
            style={{ width: "40%" }}
            display="chip"
            value={selectedFilters}
            options={groupedFilters}
            onChange={(e) => setSelectedFilters(e.value)}
            optionLabel="label"
            optionGroupLabel="label"
            optionGroupChildren="items"
            placeholder="Filters"
          />
        </div>
        {isLoadingAppointments ? (
          <div
            style={{
              width: "100%",
              minHeight: "20vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ProgressSpinner style={{ top: "230px" }} />
          </div>
        ) : (
          <>
            <div hidden={!isCalendarView}>
              <Calendar
                inline
                value={date}
                viewDate={selectedDateView?.from}
                onViewDateChange={(ev) => {
                  setSelectedDateViewValue(ev.value)
                }}
                onChange={(e) => {
                  updateList(e.value)
                }}
                style={{
                  marginTop: "5px",
                  width: "100%",
                  pDatepickerCurrentDay: { background: "red" },
                }}
              ></Calendar>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    border: "2px solid #8C28E4",
                    borderRight: 0,
                    borderBottomLeftRadius: "2px",
                    width: "30%",
                    height: "300px",
                    padding: "10px 30px 30px 30px",
                    fontFamily: "Lato",
                    overflow: "auto",
                  }}
                >
                  <h3>Recurring Controllers</h3>
                  <br />
                  {recurringParticipantControllers.map((obj, i) => {
                    return (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "20px",
                        }}
                      >
                        <div className="">
                          <b style={{ color: "#666666" }}>{obj.frequency}</b>
                          <br />
                          <span style={{ color: "#666666" }}>
                            {" with "}
                            <span style={{ color: "#8C28E4" }}>
                              {obj.staff}
                            </span>
                          </span>
                        </div>
                        <button
                          type="submit"
                          className="btn-sm"
                          style={{
                            height: "fit-content",
                          }}
                          onClick={() => openEditModal(obj)}
                        >
                          Edit
                        </button>
                      </div>
                    )
                  })}
                </div>
                <div
                  style={{
                    border: "2px solid #8C28E4",
                    width: "70%",
                    borderBottomRightRadius: "12px",
                    height: "300px",
                    padding: "10px 30px 30px 30px",
                    fontFamily: "Lato",
                    overflow: "auto",
                  }}
                >
                  <h3>Appointments</h3>
                  <br />
                  {data
                    .filter((x) => {
                      let startUnix = getDate(x.startDateTime)
                      let selectedUnix = DateTime.fromJSDate(date)
                      return (
                        startUnix >= selectedUnix &&
                        startUnix < DateTime.fromJSDate(date).plus({ days: 1 })
                      )
                    })
                    .map((obj, i) => {
                      return (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "20px",
                          }}
                        >
                          <div className="">
                            <b style={{ color: "#666666" }}>
                              {getDate(obj.startDateTime).toFormat("h:mm a")}
                            </b>
                            <br />
                            <span style={{ color: "#666666" }}>
                              {" "}
                              {obj.engagementType + " with "}
                            </span>
                            <span style={{ color: "#8C28E4" }}>
                              {obj.staff}
                            </span>
                          </div>

                          <button
                            type="submit"
                            className="btn-sm"
                            style={{ display: "block" }}
                            onClick={() => openEditModal(obj)}
                          >
                            Edit Appointment
                          </button>
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
            <div hidden={isCalendarView}>
              <TabView
                activeIndex={activeStaffSchedulingIndex}
                onTabChange={(e) => setActiveStaffSchedulingIndex(e.index)}
                panelContainerStyle={{
                  background: "rgba(0,0,0,0)",
                  padding: 0,
                }}
              >
                <TabPanel header="Pending Appointments">
                  <AppointmentsTablePending
                    pendingAppointments={pendingAppointments.filter(
                      (x) =>
                        x.type !== "DECLINED" &&
                        x.type !== "BOOKED" &&
                        x.type !== "CANCELLED" &&
                        x.type !== "CANCELLED.DENIED",
                    )}
                    getPendingActionsColumnBody={PendingAppointmentsActions}
                  />
                </TabPanel>
                <TabPanel header="Declined Appointments">
                  <AppointmentsTableDeclined
                    declinedAppointments={pendingAppointments.filter(
                      (x) =>
                        x.type === "DECLINED" || x.type === "CANCELLED.DENIED",
                    )}
                  />
                </TabPanel>
                <TabPanel header="Past Appointments">
                  <DataTable
                    value={pastAppointments}
                    sortField="startDateTime"
                    sortOrder={1}
                  >
                    <Column
                      field="startDateTime"
                      sortable
                      header="Date"
                      body={formatOrgCalDate}
                    />
                    <Column
                      field="engagementType"
                      sortable
                      header="Engagement Type"
                    />
                    <Column
                      field="engagementChannel"
                      sortable
                      bodyStyle={{ textTransform: "capitalize" }}
                      header="Engagement Channel"
                    />
                    <Column
                      field="scheduledTime"
                      sortable
                      header="Scheduled Time"
                    />
                    <Column field="staff" sortable header="Staff" />
                  </DataTable>
                </TabPanel>
                <TabPanel header="Upcoming Appointments">
                  <DataTable
                    value={upcomingAppointments}
                    sortField="startDateTime"
                    sortOrder={1}
                  >
                    <Column
                      field="startDateTime"
                      sortable
                      header="Date"
                      body={formatOrgCalDate}
                    />
                    <Column
                      field="engagementType"
                      sortable
                      header="Engagement Type"
                    />
                    <Column
                      field="engagementChannel"
                      sortable
                      bodyStyle={{ textTransform: "capitalize" }}
                      header="Engagement Channel"
                    />
                    <Column
                      field="scheduledTime"
                      sortable
                      header="Scheduled Time"
                    />
                    <Column field="staff" sortable header="Staff" />
                    <Column body={EditAppointmentsColumnBody} />
                  </DataTable>
                </TabPanel>
                <TabPanel header="Scheduled Recurring Appointments">
                  <DataTable value={recurringParticipantControllers}>
                    <Column field="newFreq" sortable header="Occurance" />
                    <Column
                      field="engagementType"
                      sortable
                      header="Engagement Type"
                    />
                    <Column
                      field="engagementChannel"
                      sortable
                      bodyStyle={{ textTransform: "capitalize" }}
                      header="Engagement Channel"
                    />
                    <Column
                      sortable
                      header="Range"
                      body={(obj) => {
                        return (
                          getDate(obj.startDate).toFormat("MM/dd/yyyy") +
                          " - " +
                          getDate(obj.endDate).toFormat("MM/dd/yyyy")
                        )
                      }}
                    />
                    <Column
                      sortable
                      header="ScheduledTime"
                      body={(obj) => {
                        return (
                          getDate(obj.startDateTime).toFormat("hh:mm a") +
                          " - " +
                          getDate(obj.endDateTime).toFormat("hh:mm a")
                        )
                      }}
                    />
                    <Column field="staff" sortable header="Staff" />
                    <Column body={EditRecurringAppointmentsColumnBody} />
                  </DataTable>
                </TabPanel>
              </TabView>
            </div>
          </>
        )}
        <Dialog
          header={() => (
            <div style={{ paddingLeft: "10px" }}>
              <h4
                style={{
                  margin: 0,
                  marginBottom: "15px",
                  color: "#757575",
                  fontSize: "20px",
                }}
              >
                Confirm Action
              </h4>
            </div>
          )}
          visible={confirmModalIsOpen}
          onHide={() => setConfirmIsOpen(false)}
          style={{ width: "25%" }}
          headerStyle={{ paddingBottom: "0px" }}
          footer={() => (
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                onClick={() => setConfirmIsOpen(false)}
                className="btn"
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
              <Button
                label="Confirm"
                type="submit"
                className={styles.btn}
                onClick={() => confirmAction()}
              />
            </div>
          )}
        >
          <h3>{confirming.message}</h3>
        </Dialog>
        <Dialog
          header={() => (
            <div
              style={{
                paddingLeft: "10px",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  marginBottom: "15px",
                  color: "#757575",
                  fontWeight: "300",
                  fontSize: "20px",
                }}
              >
                {apptModalMode}
              </h4>
            </div>
          )}
          visible={modalIsOpen}
          onHide={() => {
            closeModal()
          }}
          style={{ width: "25%" }}
          headerStyle={{ paddingBottom: "0px" }}
          footer={() => (
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                onClick={() => {
                  closeModal()
                }}
                className="btn"
                style={{ marginRight: "5px" }}
              >
                Close
              </Button>
              {activeAppointment.values.id !== 0 ? (
                <Button
                  onClick={() => cancelAppt(false, false)}
                  className="btn"
                  style={{ marginRight: "5px" }}
                >
                  Cancel Appointment
                </Button>
              ) : null}
              <Button
                label={
                  apptModalMode.includes("Submit")
                    ? "Schedule Appointment"
                    : "Edit Appointment"
                }
                type="submit"
                className={styles.btn}
                onClick={() => submitNewAppointment()}
              />
            </div>
          )}
        >
          <form
            onSubmit={activeAppointment.handleSubmit}
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-around",
            }}
          >
            {toggleRecurringAppt()}
            <div
              hidden={apptModalMode.includes("Edit")}
              style={{
                ...customStyles.inputField,
                width: "95%",
                marginBottom: "10px",
              }}
            >
              <Checkbox
                id="isRecurringController"
                onChange={activeAppointment.handleChange}
                checked={activeAppointment.values.isRecurringController}
              ></Checkbox>{" "}
              <label htmlFor="startDate">Recurring Appointment</label>
            </div>
            <div style={{ ...customStyles.inputField, width: "95%" }}>
              <label htmlFor="startDate">Timezone</label>
              <br />
              <Dropdown
                id="timezone"
                onChange={(e) => {
                  const newStartTime = DateTime.fromJSDate(
                    activeAppointment.values.startTime,
                  )
                    .setZone(activeAppointment.values.timezone?.code)
                    .setZone(e.value?.code, {
                      keepLocalTime: true,
                    })

                  activeAppointment.setFieldValue(
                    "startTime",
                    newStartTime.toJSDate(),
                  )
                  activeAppointment.setFieldValue(e.target.id, e.value)
                }}
                value={activeAppointment.values.timezone}
                style={customStyles.inputStyle}
                options={timezones}
                className={classNames({
                  "p-invalid": isFormFieldValid(activeAppointment, "timezone"),
                })}
                optionLabel="name"
                disabled={apptModalMode.includes("Edit")}
              />
            </div>
            <div style={customStyles.inputField}>
              <label htmlFor="startDate">Appointment Type</label>
              <br />
              <Dropdown
                id="serviceName"
                onChange={activeAppointment.handleChange}
                value={activeAppointment.values.serviceName}
                style={customStyles.inputStyle}
                options={services}
                className={classNames({
                  "p-invalid": isFormFieldValid(
                    activeAppointment,
                    "serviceName",
                  ),
                })}
              />
            </div>
            <div style={customStyles.inputField}>
              <label htmlFor="startTime">Duration</label>
              <br />
              <Dropdown
                id="duration"
                onChange={activeAppointment.handleChange}
                value={activeAppointment.values.duration}
                style={customStyles.inputStyle}
                options={durations}
                optionLabel="name"
                className={classNames({
                  "p-invalid": isFormFieldValid(activeAppointment, "duration"),
                })}
              />
            </div>
            <div style={customStyles.inputField}>
              <label htmlFor="startDate">Engagement Channel</label>
              <br />
              <Dropdown
                id="engagementChannel"
                onChange={activeAppointment.handleChange}
                value={activeAppointment.values.engagementChannel}
                style={{
                  ...customStyles.inputStyle,
                  textTransform: "capitalize",
                }}
                panelStyle={{ textTransform: "capitalize" }}
                options={engagementChannels}
                className={classNames({
                  "p-invalid": isFormFieldValid(
                    activeAppointment,
                    "engagementChannel",
                  ),
                })}
              />
            </div>
            {editChannelSelect(activeAppointment)}
            <div style={customStyles.inputField}>
              <Checkbox
                id="sendEmailNotifications"
                onChange={activeAppointment.handleChange}
                checked={activeAppointment.values.sendEmailNotifications}
              ></Checkbox>{" "}
              <label htmlFor="startDate">Send Email Notifications</label>
            </div>
            <div style={customStyles.inputField}>
              <Checkbox
                id="sendSMSNotifications"
                onChange={activeAppointment.handleChange}
                checked={activeAppointment.values.sendSMSNotifications}
              ></Checkbox>{" "}
              <label htmlFor="startDate">Send SMS Notifications</label>
            </div>
          </form>
        </Dialog>
      </div>
    </div>
  )
}
